// 예약 작업 관리 화면용 순수 로직 - 상태 -> 칩 라벨/색, 소요시간/다음실행 표기.
// 서버 계산(overdue 여부, nextRunDt)은 그대로 쓰고, 여기서는 "화면에 어떻게 보여줄지"만 다룬다.
import dayjs from 'dayjs';

export const STATUS_META = {
  SUCCESS: { label: '성공', color: 'success' },
  FAIL: { label: '실패', color: 'error' },
  RUNNING: { label: '실행중', color: 'info' },
};

export const NO_HISTORY_META = { label: '기록없음', color: 'default' };

/** lastStatus(SYS_JOB_RUN_HIS.STATUS) -> 화면에 보일 {label, color}. null/미지원 값은 "기록없음". */
export const statusMeta = (status) => STATUS_META[status] || NO_HISTORY_META;

export const JOB_SRC_LABEL = {
  BACKEND: '백엔드',
  HOST: '서버',
};

export const jobSrcLabel = (jobSrc) => JOB_SRC_LABEL[jobSrc] || jobSrc || '-';

/** 밀리초 -> "1.2초"/"850ms"/"3분 5초" 등 사람이 읽기 쉬운 표기. null/0 이하는 '-'. */
export const formatDuration = (durationMs) => {
  if (durationMs === null || durationMs === undefined || Number.isNaN(Number(durationMs))) {
    return '-';
  }
  const ms = Number(durationMs);
  if (ms < 0) return '-';
  if (ms < 1000) return `${ms}ms`;
  const totalSec = ms / 1000;
  if (totalSec < 60) {
    return `${totalSec.toFixed(1)}초`;
  }
  const totalMin = Math.floor(totalSec / 60);
  const remSec = Math.round(totalSec % 60);
  return remSec > 0 ? `${totalMin}분 ${remSec}초` : `${totalMin}분`;
};

/** 날짜/시각 포맷(없으면 '-'). */
export const formatDateTime = (value) => {
  if (!value) return '-';
  const d = dayjs(value);
  return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : '-';
};

/** 목록용 짧은 포맷(오늘이면 시각만). */
export const formatDateTimeShort = (value) => {
  if (!value) return '-';
  const d = dayjs(value);
  if (!d.isValid()) return '-';
  return d.isSame(dayjs(), 'day') ? d.format('HH:mm:ss') : d.format('MM-DD HH:mm');
};

/**
 * next-run 표기. overdue면 "지연"을 분명히 드러낸다.
 * nextRunDt가 없으면(서버가 계산 못 함) '-'.
 */
export const formatNextRun = (nextRunDt, overdue) => {
  if (overdue) return '지연됨';
  if (!nextRunDt) return '-';
  const d = dayjs(nextRunDt);
  return d.isValid() ? d.format('MM-DD HH:mm') : '-';
};

/** 수동 실행 버튼 노출 여부 - BACKEND + MANUAL_RUN_YN='Y'만. */
export const canRunManually = (job) => Boolean(job) && job.jobSrc === 'BACKEND' && job.manualRunYn === 'Y';
